import type { PanelItem } from '@rta/rta-blueprint-library';

// Openings and reservations, not appliances — they have their own cutout/spacer menu entries.
export const NON_APPLIANCE_CATEGORY_KEYS = new Set(['cutout', 'utility-cutout', 'hole', 'outlet', 'vent', 'passthrough', 'spacer', 'system']);

/**
 * Whether a panel item is a catalog appliance the designer can swap or open properties on.
 * Hand-entered custom appliances have their own "Custom Appliance Properties" entry, and
 * cutouts/vents/outlets/spacers are not appliances at all. Deliberately NOT keyed off
 * `item.vendor`, which only records the brand and is null for hand-entered items.
 */
export const isSwappableAppliance = (panelItem: PanelItem): boolean => {
	const { item } = panelItem;
	if (!item || item.sku === 'CUSTOM' || item.override) return false;
	return !NON_APPLIANCE_CATEGORY_KEYS.has(item.category?.key ?? '');
};
